// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ni-c";
export var backButton = "_ni-4";
export var backIcon = "_ni-5";
export var chevronShortcut = "_ni-6";
export var container = "_ni-1";
export var editor = "_ni-8";
export var editorWrapper = "_ni-7";
export var prefix = "_ni-2";
export var searchIcon = "_ni-3";
export var suffix = "_ni-9";
export var suffixContent = "_ni-a";
export var suffixText = "_ni-b";
export var wrapper = "_ni-0";